import { defineComponent as _defineComponent } from 'vue'
import C4EIcon from "@/components/commons/C4EIcon.vue";
import {VestingPeriods} from "@/models/store/account";
import {BigDecimal} from "@/models/store/big.decimal";
import {BigIntWrapper, Coin, DecCoin} from "@/models/store/common";
import CoinAmount from "@/components/commons/CoinAmount.vue";
import {useI18n} from "vue-i18n";
import {calculateLockedVesting} from "@/utils/vesting-utils";
import {useBlockStore} from "@/store/block.store";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioVestingLine',
  props: {
    vesting: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props;
const i18n = useI18n();

const blockStore = useBlockStore();

function convertAmount( amount: bigint | number | BigDecimal | Coin | DecCoin){
  if( typeof amount === 'bigint'){
    return new BigIntWrapper(amount);
  } else {
    return amount;
  }
}

const calculateDays = computed(() => {
  const oneHour = 60 * 60 * 1000;
  const oneDay = 24 * oneHour;
  let timeRemaining = new Date(props.vesting.endTime*1000).getTime() - Date.now();
  return timeRemaining/oneDay < 1
    ?
    `${Math.floor(timeRemaining / oneHour)} ${i18n.t("PORTFOLIO_VIEW.HOURS")} ${Math.floor(timeRemaining/60000) % 60} ${i18n.t("PORTFOLIO_VIEW.MINS")}`
    :
    `${Math.floor(timeRemaining / oneDay)} ${i18n.t("PORTFOLIO_VIEW.DAYS")}`;
});

function sumVestingAmount(): bigint {
  let sumAmount = 0n;
  props.vesting.amount.forEach((item) => sumAmount += item.amount);

  return calculateLockedVesting(props.vesting.startTime*1000, props.vesting.endTime*1000, blockStore.getLatestBlock.time.getTime(), sumAmount);
}


const __returned__ = { props, i18n, blockStore, convertAmount, calculateDays, sumVestingAmount, C4EIcon, CoinAmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})